<template>
  <div>
    <div class="form" v-if="searchList.length > 0">
      <el-form
        :model="formData"
        :inline="true"
        label-position="left"
        class="formData"
      >
        <el-form-item
          v-for="item in searchList"
          :key="item.code"
          :label="item.title"
          label-width="100px"
          style="margin-left: 33px"
        >
          <template #label>
            <el-popover
              v-if="item.title.length > 6"
              placement="top-start"
              :width="item.title.length * 12"
              trigger="hover"
              :content="item.title"
            >
              <div
                slot="reference"
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  width: 100px;
                "
              >
                {{ item.title }}
              </div>
            </el-popover>
            <div v-else>{{ item.title }}</div>
          </template>
          <component
            :is="item.name"
            :item="item"
            :formData="formData"
            @queryList="queryList"
          >
          </component>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import components from "@/views/home/CompExport";

export default {
  components: { ...components },
  props: {
    searchList: {
      type: Array,
      default: () => [],
    },

    formData: {
      type: Object,
      default: () => {},
    },
    pageNumber: {
      type: Number,
      default: 1,
    },
  },

  inject: ["getViewList"],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    title() {
      return this.$store.state.formData.tableData;
    },

    refresh() {
      return this.$store.state.formData.refresh;
    },
    tableData() {
      return this.$store.state.formData.tableData;
    },
  },
  watch: {
    refresh(val) {
      if (val) {
        this.$router.push(
          {
            query: {
              code: this.tableData.formId,
            },
          },
          () => {}
        );
        this.queryList();
      }
    },
  },
  methods: {
    async drawerPage() {
      this.loading = true;
      await this.$store.dispatch("formData/getDetailData", {
        formId: this.$route.query.code,
        type: "add",
      });
      this.loading = false;
    },
    queryList() {
      this.getViewList(null, null, false);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-input__inner {
  height: 34px;
}
/deep/ .el-input--small .el-input__inner {
  height: 32px;
}

/deep/.el-form-item {
  margin-bottom: 10px;
}
// /deep/ .el-form--inline .el-form-item__label {
//   white-space: normal;
// }
/deep/ .el-form-item__content {
  line-height: 34px;
  width: calc(100% - 100px);
}

.form {
  background-color: #fff;
  padding: 20px 0 10px;
  position: relative;
  overflow: hidden;
  .isRoll {
    max-height: 360px;
    overflow: auto;
  }
}
@media only screen and (max-width: 900px) {
  .el-form-item {
    width: calc(100% - 55px);
  }
}

@media only screen and (min-width: 900px) {
  .el-form-item {
    width: calc(50% - 55px);
  }
}

@media only screen and (min-width: 1400px) {
  .el-form-item {
    width: calc(33% - 55px);
  }
}

@media only screen and (min-width: 1920px) {
  .el-form-item {
    width: calc(25% - 55px);
  }
}

/deep/ .el-button:focus {
  color: #606266;
  border-color: #dcdfe6;
  background-color: unset;
}
/deep/ .el-button:hover {
  color: #107FFF;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

/deep/ .el-input__inner {
  height: 34px;
  line-height: 34px;
  &::placeholder {
    font-size: 14px;
    color: #86909c;
  }
}

/deep/ .el-form-item__label {
  line-height: 34px;
}
</style>